export default function Info(){
    return(
        <div className="info">
            <header>
                <img src="https://avatars.githubusercontent.com/u/49182604?v=4" alt="display" />
                <h2>Amelia Dutta</h2>
                <h4>Web Developer</h4>
                <nav className="navbar">
                    <button className="email"><i class="fa-solid fa-envelope"></i><a href="mailto:amelia.dutta.02@gmail.com"> Email</a></button>
                    <button className="website"><i class="fa-solid fa-globe"></i><a href="https://amelia2802.github.io/Portfolio/" target="_blank"  rel="noreferrer"> Website</a></button>
                </nav>
            </header>
        </div>
    )
}